import React, { useState } from "react";
import PriceField from "./PriceField";

export default function DeliveryRules({ values, change }) {

    const [entry, setEntry] = useState({ orderValue: 0, deliveryPrice: 0 });

    function changeEntry(name, val) {
        setEntry({
            ...entry,
            [name]: val
        })
    }

    return <div className="deliveryRules">
        <div>Add more rules by selecting order value and delivery price</div>
        <div className="existing">
            <div className="heading flexy featureFont">
                <span>ORDER VALUE</span>
                <span>DELIVERY COST</span>
            </div>
            {values
                .sort((a, b) => {
                    return a.orderValue - b.orderValue
                })
                .map(v => (
                    <div
                        style={{ paddingLeft: "15px" }}
                        className="price-item"
                        key={v.id || JSON.stringify(v)}
                    >
                        <div className="details flexy">
                            <span>{`£${(v.orderValue / 100).toFixed(2)}`}</span>
                            <span>{`£${(v.deliveryPrice / 100).toFixed(2)}`}</span>
                        </div>
                        <div
                            className="remove"
                            onClick={() => {
                                change([...values].filter(val => {
                                    // If there is id filter by id's, otherwise compare values
                                    return v.id
                                        ? v.id !== val.id
                                        : `${v.orderValue}-${v.deliveryPrice}` !== `${val.orderValue}-${val.deliveryPrice}`
                                }))
                            }}
                        >x</div>
                    </div>
                ))}
        </div>
        <div className="new flexy" style={{ marginTop: "10px" }}>
            <PriceField
                style={{ marginBottom: "0px" }}
                value={entry.orderValue}
				onChange={val => changeEntry("orderValue", val)}
				tooltipSide="left"
            />
            <PriceField
                style={{ marginBottom: "0px" }}
                value={entry.deliveryPrice}
                onChange={val => changeEntry("deliveryPrice", val)}
            />
            <button
                style={{ width: "39px" }}
                className="mini add"
                onClick={() => {
                    change([...values, entry]);
                    setEntry({ orderValue: 0, deliveryPrice: 0 })
                }}
            >+</button>
        </div>
    </div>

}

